module.exports = __webpack_public_path__ + "static/media/file.a4b0ff2a.png";